module.exports = __webpack_public_path__ + "img/logo.d47a5059.svg";